import { Modal, Button } from "react-bootstrap";

const LoginPromptModal = ({
  show,
  handleClose,
  showLoginButton,
  onLoginClick,
}) => {
  return (
    <Modal show={show} onHide={handleClose} size="sm">
      <Modal.Header closeButton>
        <Modal.Title as="h5">ログインしてください</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {showLoginButton
            ? "この機能の使用には、アカウント登録（無料）の上、ログインが必要です。ログイン後、もう一度ボタンを押してください。"
            : "この機能の使用には、アカウント登録（無料）の上、ログインが必要です。右上のログインボタンからログインの上、もう一度選択してください。"}
        </p>
        {showLoginButton && (
          <Button variant="primary" onClick={onLoginClick}>
            ログイン
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LoginPromptModal;
